import { render, staticRenderFns } from "./WidgetCHSCommentary.vue?vue&type=template&id=70d12ee9&"
import script from "./WidgetCHSCommentary.vue?vue&type=script&lang=js&"
export * from "./WidgetCHSCommentary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetCHSCommentary.vue"
export default component.exports